import { FEATURES } from '../terminology/features';
import { DEFAULT_FITMENT_CATALOG_LABEL } from '../utils/fitmentCatalogLabel';
export function nativeNavigation(vehicleLabel: string, productGuides: boolean, serviceBooking: boolean) {
  return [
    { to: '/dashboard', label: FEATURES.dashboard },
    { to: '/products', label: FEATURES.products },
    { to: '/vehicles', label: vehicleLabel || DEFAULT_FITMENT_CATALOG_LABEL },
    ...(productGuides ? [{ to: '/product-guides', label: FEATURES.configurators }] : []),
    ...(serviceBooking ? [{ to: '/service-booking', label: FEATURES.serviceBooking }] : []),
    { to: '/imports', label: FEATURES.imports },
    { to: '/reports', label: FEATURES.reports },
    { to: '/storefront', label: FEATURES.settings },
  ];
}
